import { React, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { Button } from '../../../components/ui/legacy'

import { accountService } from '../../../service/AccountService'

import UserInfo from '../../../features/account-management/account-list/UserInfo'
import BookList from '../../../features/account-management/account-list/BookList'
import DeviceList from '../../../features/account-management/account-list/DeviceList'
import { useNav } from '../../../hooks/useNav'
import { PATH } from '../../../data/router_path'
import useGetAccountByUUID from '../../../features/account-management/account-list/hooks/useGetAccountById'
import ConfirmationBox from '../../../components/ui/ConfirmationBox'
import { showErrorToast } from '../../../utils/showToast'
const DetailAccountPage = () => {
  const navigate = useNav()
  const uuid = useParams().uuid
  const { data: userData, isLoading } = useGetAccountByUUID(uuid)
  const [isConfirmChangePassword, setIsConfirmChangePassword] = useState(false)
  const handleResetPassword = () => {
    showErrorToast({ message: 'Tính năng chưa được phát triển' })
    setIsConfirmChangePassword(false)
  }
  if (isLoading) {
    return <div>Loading...</div>
  }
  return (
    <>
      <form className="pb-12">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Icon
              className="global-icon cursor-pointer"
              icon="ph:arrow-left"
              onClick={() => navigate(PATH.ACCOUNT.LIST)}
            />
            <div className="ml-2">
              <p className="font-medium">{userData.schoolId}</p>
              <p className="text-2xl font-bold">{userData.fullName || '--'}</p>
            </div>
            <div className="ml-8">
              <div className="flex items-center space-x-2">
                {userData.groupUuids
                  .map((item) => {
                    return item.name
                  })
                  .sort((a, b) => (a === 'Admin' ? -1 : b === 'Admin' ? 1 : 0))
                  .slice(0, 3)
                  .map((group, index) => (
                    <span
                      key={index}
                      className={`rounded-full px-4 py-1 text-sm font-bold ${
                        group === 'Admin'
                          ? 'bg-blue-500 text-white'
                          : 'bg-gray-200'
                      }`}
                    >
                      {group}
                    </span>
                  ))}
                {userData.groupUuids.length > 3 && (
                  <div className="group relative">
                    <span className="rounded-full bg-gray-200 px-2 py-1 text-sm font-bold text-gray-800">
                      +{userData.groupUuids.length - 3}
                    </span>
                    <div className="absolute left-0 mt-2 hidden w-48 rounded-lg border border-gray-300 bg-white p-2 shadow-lg group-hover:block">
                      {userData.groupUuids
                        .map((item) => {
                          return item.name
                        })
                        .sort((a, b) =>
                          a === 'Admin' ? -1 : b === 'Admin' ? 1 : 0
                        )
                        .slice(3)
                        .map((group, index) => (
                          <div key={index} className="px-2 py-1">
                            {group}
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <Button
            variant={'primary'}
            onClick={() => {
              navigate(PATH.ACCOUNT.EDIT(uuid))
            }}
          >
            Chỉnh sửa thông tin
          </Button> */}
          {/* <Button
            type="button"
            variant="primary"
            onClick={() => setIsConfirmChangePassword(true)}
            className="rounded-xl"
          >
            Đặt lại mật khẩu
          </Button> */}
        </header>
        <section className="mt-4 flex w-full">
          <div className="mt-8 w-full">
            <UserInfo userData={userData} />
            <BookList id={uuid} />
            <DeviceList />
          </div>
        </section>
      </form>
      {isConfirmChangePassword && (
        <ConfirmationBox
          title="Xác nhận reset password?"
          message="Mật khẩu sẽ trở về mặc định"
          onConfirm={handleResetPassword}
          onCancel={() => setIsConfirmChangePassword(false)}
        />
      )}
    </>
  )
}

export default DetailAccountPage
